/**
 * The rule of the address a user signs in with, shared by the API schemas
 * (creation, update, login) and the web forms: ASCII only, checked before
 * the email format so its message is the one shown.
 *
 * @module @efacture/core/constants/user-email
 */
/** Matches a string holding ASCII characters only. */
export const USER_EMAIL_ASCII_PATTERN = /^[\x00-\x7F]*$/;
/** Refusal of an address holding a character outside ASCII. */
export const USER_EMAIL_NON_ASCII_MESSAGE = "L'adresse e-mail ne doit contenir ni lettre accentuée ni autre caractère non ASCII " +
    "(ex. aissatou@… et non aïssatou@…).";
/**
 * The stored form of a user's address: lowercased, surrounding spaces
 * dropped. Every lookup and every write of a user's address goes through it.
 */
export function normalizeUserEmail(email) {
    return email.trim().toLowerCase();
}
//# sourceMappingURL=user-email.js.map